import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { ManageallsubscriptionsComponent } from './components/manageallsubscriptions/manageallsubscriptions.component';
import { SubscribeeventsComponent } from './components/subscribeevents/subscribeevents.component';
import { UnsubscribeeventsComponent } from './components/unsubscribeevents/unsubscribeevents.component';
import { UnsubscribeComponent } from './components/unsubscribe/unsubscribe.component';
import { UnsubscribefromnotificationComponent } from './components/unsubscribefromnotification/unsubscribefromnotification.component';

const routes: Routes = [
  { path: 'subscribetoevents', component: SubscribeeventsComponent },
  { path: 'subscribe', component: SubscribeeventsComponent },
  { path: 'unsubscribetoevents', component: UnsubscribeeventsComponent },
  { path: 'unsubscribe', component: UnsubscribeComponent },
  { path: 'unsubscribe/:listid', component: UnsubscribeComponent },
  { path: 'manageallsubscriptions', component: ManageallsubscriptionsComponent },
  { path: 'unsubscribefromnotification', component: UnsubscribefromnotificationComponent },  
  { path: '', redirectTo: '/subscribe', pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
